import { render, staticRenderFns } from "./FFSnackbar.vue?vue&type=template&id=55e05ede&scoped=true&"
import script from "./FFSnackbar.vue?vue&type=script&lang=js&"
export * from "./FFSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./FFSnackbar.vue?vue&type=style&index=0&id=55e05ede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e05ede",
  null
  
)

export default component.exports